var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spotify-player"},[_c('iframe',{ref:"embed",attrs:{"src":_vm.embedUrl,"title":_vm.iframeTitle,"height":_vm.height,"width":"100%","frameborder":"0","allowfullscreen":"","allow":"clipboard-write; encrypted-media; fullscreen; picture-in-picture"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }